import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {convertDate, createDateTimeObjectFromDate, getGetHeaders, getLocalTimeZoneName} from '../shared/functions';
import {setDefaultTableSort, filterCaseInsensitive, getTableState, sortNumber} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {RESOURCES as searchResources} from '../fuseSearchResourceMap';
import ViewButtonByLocationTransferId from '../buttons/ViewButtonByLocationTransferId';
import {tableStyles} from '../shared/styles-table';
import '../shared/react-table.css';

class TransferListTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataComplete: false,
            dataList: [],
            dataTable: [],
            message: null
        };
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData(this.props.transferType);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.memo !== this.props.memo ||
            nextProps.startDate !== this.props.startDate ||
            (!nextProps.listComplete && this.props.listComplete)
        ) {
            this.setState({
                dataComplete: false,
                dataList: [],
                dataTable: [],
                message: null
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.memo !== this.props.memo ||
            prevProps.startDate !== this.props.startDate ||
            (prevProps.listComplete && !this.props.listComplete)
        ) {
            this.fetchData(this.props.transferType);
        }
    }

    /**
     * Get Transfers data for selected Since Date or by Memo
     *
     * @param transferType
     */
    fetchData(transferType) {
        const startDate = this.props.startDate;
        let params = {
            filter: {
                date_since: startDate
            },
        };
        let resource;
        let errorMessage = 'Sorry, there was an error retrieving Transfers.';
        let noneMessage;
        let startDateStr = '.';
        if (startDate) {
            const date = new Date(startDate);
            startDateStr = ' since ' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' + date.getUTCFullYear() + '.';
        }

        if (transferType === 'memo') {
            params.filter.filter_memo = this.props.memo;
            resource = searchResources.TransfersByMemo.GET_LIST(params);
            noneMessage = 'No Transfers with Memo \'' + this.props.memo + '\'.'
        }
        if (transferType === 'incoming') {
            resource = searchResources.Transfers.GET_LIST(params);
            noneMessage = 'No Transfers en route' + startDateStr;
        }
        if (transferType === 'received') {
            resource = searchResources.ReceivedTransfers.GET_LIST(params);
            noneMessage = 'No Transfers received' + startDateStr;
        }

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.error) {
                this.storeProcessedData([], false, errorMessage);
            } else if (result.data && result.data.length > 0 && result.data[0].location_from) {
                // Process Incoming/Received Transfer data
                this.processSearchData(result.data);
            } else if (result.data && result.data.payload) {
                // Process Transfer by Memo data
                this.processData(result.data.payload);
            } else {
                this.storeProcessedData([], false, noneMessage);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            this.storeProcessedData([], false, errorMessage);
        });
    }

    /**
     * Process array of Transfers by Memo
     *
     * @param data
     */
    processData(data) {
        const localTZ = getLocalTimeZoneName();
        let processedData = [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                let dateSent = convertDate(item.sent_time) + ' ' + localTZ;
                let dateSentDate = createDateTimeObjectFromDate(item.transfer_sent_time);
                let dateReceived = (item.received_time) ? convertDate(item.received_time) + ' ' + localTZ : '';
                let dateReceivedDate = createDateTimeObjectFromDate(item.received_time);
                let result = {
                    date_received: dateReceived,
                    date_transferred: dateSent,
                    date_transferred_date: dateSentDate,
                    id: item.transfer_id,
                    location_from: item.location_from,
                    location_to: item.location_to,
                    memo: item.memo,
                    received: item.received,
                    received_time: item.received_time,
                    received_time_date: dateReceivedDate,
                    sent_time: item.sent_time,
                    transfer_id: item.transfer_id,
                };
                processedData.push(result);
            }
        }
        this.storeProcessedData(processedData, true);
    }

    /**
     * Process array of Incoming or Received Transfers
     *
     * @param data
     */
    processSearchData(data) {
        const localTZ = getLocalTimeZoneName();
        let processedData = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let dateSent = convertDate(item.transfer_sent_time) + ' ' + localTZ;
            let dateSentDate = createDateTimeObjectFromDate(item.transfer_sent_time);
            let dateReceived = (item.received_time) ? convertDate(item.received_time) + ' ' + localTZ : '';
            let dateReceivedDate = createDateTimeObjectFromDate(item.received_time);
            let result = {
                date_received: dateReceived,
                date_transferred: dateSent,
                date_transferred_date: dateSentDate,
                id: item.transfer_id,
                location_from: item.location_from,
                location_to: item.location_to,
                memo: item.transfer_memo,
                received: item.transfer_received,
                received_time: (item.received_time) ? item.received_time : 'N/A',
                received_time_date: dateReceivedDate,
                sent_time: item.transfer_sent_time,
                state_from: item.location_from_state,
                state_to: item.location_to_state,
                transfer_id: item.transfer_id,
            };
            processedData.push(result);
        }
        this.storeProcessedData(processedData, true);
    }

    /**
     * Store data from processing and lift state
     *
     * @param data
     * @param success
     * @param message
     */
    storeProcessedData(data, success, message = null) {
        this.setState({
            dataComplete: true,
            dataList: data,
            dataTable: data,
            message: message
        }, () => {
            this.props.onDataComplete(true);
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                dataTable: tableData
            });
        }
    }

    render() {
        const {
            basePath,
            transferType
        } = this.props;

        const {
            dataComplete,
            dataList,
            message
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'sent_time', order: 'ASC'});

        const tableColumns = [
            {
                Header: '',
                accessor: 'date_transferred',
                style: tableStyles.hide,
                headerStyle: tableStyles.hide
            },
            {
                Header: 'Sent',
                accessor: 'date_transferred_date',
                Cell: props => (
                    <span>{props.row.date_transferred}</span>
                ),
                width: 180,
                headerStyle: tableStyles.left
            },
            {
                Header: 'Transfer ID',
                accessor: 'transfer_id',
                sortMethod: (a, b) => sortNumber(a, b),
                width: 180,
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>From<br/>Location</span>),
                accessor: 'location_from',
                width: 100,
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>To<br/>Location</span>),
                accessor: 'location_to',
                width: 100,
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>From<br/>State</span>),
                accessor: 'state_from',
                width: 80,
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>To<br/>State</span>),
                accessor: 'state_to',
                width: 80,
                headerStyle: tableStyles.left
            }
        ];
        if (transferType === 'received') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'date_received',
                    style: tableStyles.hide,
                    headerStyle: tableStyles.hide
                },
                {
                    Header: 'Received',
                    accessor: 'received_time_date',
                    Cell: props => (
                        <span>{props.row.date_received}</span>
                    ),
                    width: 180,
                    headerStyle: tableStyles.left
                }
            );
        }
        tableColumns.push(
            {
                Header: 'Memo',
                accessor: 'memo',
                headerStyle: tableStyles.left
            },
            {
                Header: '',
                accessor: 'id',
                filterable: false,
                sortable: false,
                Cell: row => (
                    <ViewButtonByLocationTransferId
                        basePath={basePath}
                        record={{
                            location_from: row.row.location_from,
                            location_to: row.row.location_to,
                            memo: row.row.memo,
                            transfer_id: row.row.transfer_id,
                            transfer_type: transferType
                        }}
                    />
                ),
                width: 80,
                styles: {...tableStyles.right, ...tableStyles.noPadding}
            }
        );
        return (
            <div>
                {dataComplete && dataList.length > 0 &&
                    <div className="list-table-container">
                        <ReactTable
                            key="table-incoming-transfers-list"
                            data={dataList}
                            columns={tableColumns}
                            defaultPageSize={20}
                            showPagination={true}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, this.transfersReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.transfersReactTable)}
                            ref={(r) => this.transfersReactTable = r}
                            resizable={false}
                            minRows={1}
                        />
                    </div>
                }
                {dataComplete && dataList.length === 0 &&
                    <p>{message}</p>
                }
            </div>
        );
    }
}

TransferListTable.propTypes = {
    basePath: PropTypes.string,
    listComplete: PropTypes.bool,
    memo: PropTypes.string,
    onDataComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    transferType: PropTypes.string
};

TransferListTable.defaultProps = {
    listComplete: false,
    memo: null,
    startDate: null,
    transferType: 'incoming'
};

export default TransferListTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferListTable.js